module.exports = __webpack_public_path__ + "img/bybit_6.00f4e641.png";